import './opacity-view.scss';

const SubmittedProfileOpacityView = () => {
  return <div className={'opacity-view'}/>
}

export default SubmittedProfileOpacityView;